import { buildReportData } from './normalizers';

export const EMPTY_DATA = buildReportData({} as any);
